import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { DashboardScope } from '@api/domain/types';
import type { DashboardResultImageData } from '@api/domain/types';

import DashboardRowImage from '@v2/pages/dashboard/common/components/DashboardRowImage';
import { rowHasImage } from '@v2/pages/dashboard/common/helpers';
import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';

interface DashboardListDivergingRowNameProps extends WithColor {
  scope: DashboardScope;
  name: string;
  imageHash?: string | null;
  imageData?: DashboardResultImageData | null;
  side: 'left' | 'right';
}

const DashboardListDivergingRowName: FC<DashboardListDivergingRowNameProps> = ({ C, scope, name, imageHash, imageData, side }) => {
  const isLeft = side === 'left';

  const image = rowHasImage(scope) ? <DashboardRowImage imageHash={imageHash} imageData={imageData} /> : null;

  const text = (
    <Text style={[font[ROW_LAYOUT.name.fontType], { flex: 1, color: C('Label/Light/Primary'), textAlign: isLeft ? 'right' : 'left' }]} numberOfLines={1}>
      {name}
    </Text>
  );

  return (
    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: scale(8) }}>
      {isLeft ? (
        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', marginRight: scale(8), gap: scale(8) }}>
          {text}
          {image}
        </View>
      ) : (
        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', marginLeft: scale(8), gap: scale(8) }}>
          {image}
          {text}
        </View>
      )}
    </View>
  );
};

export default ColorWrapper(DashboardListDivergingRowName);
